import { createSlice } from "@reduxjs/toolkit";
import {
  getRoleModuleById,
  // deleteRoleModule,
  // editRoleModule,
  // getRoleModuleById,
  // getRoleModuleList,
  getRoleModulePage, getRoleModuleSidebar, updateRoleModul,
  // postRoleModule,
  // getRoleModuleByRegionalId,
} from "../action/roleModuleAction";

const initialState = {
  dataRoleModule: [],
  dataByIdRoleModule: '',
  dataRoleModuleByRegionalId: [],
  dataRoleModuleSidebar: [],
  dataRoleModuleState: [],
  idRoleModule: "",
  state: "",
  isOpenForm: false,
  isLoading: false,
};
const roleModuleSlice = createSlice({
  name: "roleModule",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.type === 'close') {
        state.dataByIdRoleModule = []
        state.idRoleModule = ''
      }
      if (action.payload.state === "edit") {
        state.dataByIdRoleModule = action.payload.data;
        state.idRoleModule = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdRoleModule = action.payload.data;
        state.idRoleModule = action.payload.id;
      }
    },
  },
  extraReducers: {
    [getRoleModulePage.pending]: (state) => {
      state.isLoading = true;
    },
    [getRoleModulePage.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataRoleModule = action.payload.data;
      state.isLoading = false;
    },
    [getRoleModulePage.rejected]: (state) => {
      state.isLoading = false;
    },
    [getRoleModuleById.pending]: (state) => {
      state.isLoading = true;
    },
    [getRoleModuleById.fulfilled]: (state, action) => {
      console.log(action.payload);
      state.dataByIdRoleModule = action.payload.data;
      state.isLoading = false;
    },
    [getRoleModuleById.rejected]: (state) => {
      state.isLoading = false;
    },
    [getRoleModuleSidebar.pending]: (state) => {
      state.isLoading = true;
    },
    [getRoleModuleSidebar.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataRoleModuleSidebar = action.payload.sidebar;
      state.dataRoleModuleState = action.payload.data;
      state.isLoading = false;
    },
    [getRoleModuleSidebar.rejected]: (state) => {
      state.isLoading = false;
    },
    // [getRoleModuleList.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getRoleModuleList.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.dataRoleModule = action.payload.data
    //   state.isLoading = false
    // },
    // [getRoleModuleList.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [getRoleModuleById.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getRoleModuleById.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.dataRoleModule = action.payload.data
    //   state.isLoading = false
    // },
    // [getRoleModuleById.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [getRoleModuleByRegionalId.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getRoleModuleByRegionalId.fulfilled]: (state, action) => {
    //   // console.log(action.payload)
    //   state.dataRoleModuleByRegionalId = action.payload.data
    //   state.isLoading = false
    // },
    // [getRoleModuleByRegionalId.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [postRoleModule.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [postRoleModule.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.isOpenForm = false
    //   state.isLoading = false
    // },
    // [postRoleModule.rejected]: (state) => {
    //   state.isLoading = false
    // },
    [updateRoleModul.pending]: (state) => {
      state.isLoading = true
    },
    [updateRoleModul.fulfilled]: (state, action) => {
      state.isLoading = false
    },
    [updateRoleModul.rejected]: (state) => {
      state.isLoading = false
    },
    // [deleteRoleModule.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [deleteRoleModule.fulfilled]: (state, action) => {
    //   state.isOpenForm = false
    //   state.isLoading = false
    //   state.dataByIdRoleModule = []
    //   state.idRoleModule = 0
    // },
    // [deleteRoleModule.rejected]: (state) => {
    //   state.isLoading = false
    // },
  },
});

export const { openForm } = roleModuleSlice.actions;
export default roleModuleSlice.reducer;
